export enum RateUnits {
  L = 'l',
  ML = 'ml',
  MG = 'mg',
  G = 'g',
  KG = 'kg',
  LB = 'lb',
  GAL = 'gal',
  QT = 'qt',
  OZ = 'oz',
  PNT = 'pnt',
  'US GAL' = 'US gal',
  'US PNT' = 'US pnt',
}

export function isValidRateUnit(unit: unknown): unit is RateUnits {
  if (typeof unit !== 'string') return false

  const lowerUnit: string = unit.toLowerCase()
  return Object.values(RateUnits).some((rateUnit) => rateUnit.toLowerCase() === lowerUnit)
}
